'use client';

import { useState } from 'react';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { UtilTitleSimpleTextImage } from '@sapientpro/sapientpro-data-models';
import styles from './SideRevealingPoints.module.scss';
import { theme } from '../../store/theme';

const SideRevealingPoints = ({
  points,
}: {
  points: UtilTitleSimpleTextImage[];
}) => {
  const [activePoint, setActivePoint] = useState<UtilTitleSimpleTextImage | null>(points[0] ?? null);
  const appTheme = useAtomValue(theme);

  return (
    <div className={styles.sideRevealingPoints}>
      <div className={styles.sideRevealingPoints__list}>
        {points.map((point) => (
          <div
            key={point.id}
            className={styles.sideRevealingPoints__listItem}
          >
            <button
              type='button'
              onClick={() => setActivePoint(point)}
              className={classNames(styles.sideRevealingPoints__listItemButton, 'header4', {
                [styles.sideRevealingPoints__listItemButton_active]: activePoint?.id === point.id,
              })}
            >
              {point.title}
              <svg className={styles.sideRevealingPoints__listItemButtonIcon}>
                <use
                  xlinkHref='/media/arrow-right-bold.svg#arrowRight'
                  href='/media/arrow-right-bold.svg#arrowRight'
                />
              </svg>
            </button>
            <div
              className={classNames(styles.sideRevealingPoints__listItemContent, {
                [styles.sideRevealingPoints__listItemContent_hidden]: activePoint?.id !== point.id,
              })}
            >
              <p className={classNames(styles.sideRevealingPoints__listItemContentDescription, 'bodyLarge')}>
                {point.description}
              </p>
              {activePoint?.id === point.id && (
                <img
                  src={appTheme === 'dark' ? point.darkImage?.url : point.image.url}
                  alt={point.title}
                  className={styles.sideRevealingPoints__listItemContentImage}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      {activePoint && (
        <div className={styles.sideRevealingPoints__content}>
          <p className={classNames(styles.sideRevealingPoints__contentMainDescription, 'bodyLarge')}>
            {activePoint.description}
          </p>
          <img
            src={appTheme === 'dark' ? activePoint.darkImage?.url : activePoint.image.url}
            alt={activePoint.title}
            className={styles.sideRevealingPoints__contentImage}
          />
        </div>
      )}
    </div>
  );
};

export default SideRevealingPoints;
